//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from '../common/helpers/HttpHelper'
import environments from '../common/environments/environment';
const http = new httpHelper();


export const CreateNewUserActions = {
    GetCreateNewUserJSON: getCreateNewUserJSON,
    GetUserDetails: getUserDetails,
    GetUserRole: getUserRole,
    GetLanguage: getLanguage,
    CreateNewUser: createNewUser,
    TrackAction: trackAction,
    GetTimeZone: getTimeZone
}

function trackAction(payload) {
    return http.adminPost(environments.TRACK_ADMIN_ACTIONS, payload);
}

function getCreateNewUserJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.CREATE_NEW_USER_JSON);
}

function getUserDetails(activeEmail) {
    return http.graphUserApiGet(activeEmail);
}

function getUserRole() {
    return http.adminGet(environments.USER_ROLE);
}

function getLanguage(countryCode) {
    let refRole = environments.USER_LANGUAGE.replace("{countryCode}", countryCode)
    return http.adminGet(refRole);
}

function createNewUser(payload) {
    return http.adminPost(environments.CREATE_NEW_USER, payload);
}

function getTimeZone(language) {
    return http.getTimezoneData(environments.TIMEZONE.replace('{lang}', language));
}
